import { makeStyles } from "@material-ui/core/styles";
import { grey300 } from "../../../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    maxWidth: "50vw",
  },
  sliderContainer: {
    marginTop: 16,
    width: 440,
  },
  textInfo: {
    fontSize: 14,
  },
  input: {
    width: 40,
  },
  textFee: {
    fontWeight: 700,
  },
  sliderWrapper: {
    padding: `${theme.spacing(2)}px 0`,
    borderTop: `solid 1px ${grey300}`,
    borderBottom: `solid 1px ${grey300}`,
    margin: `${theme.spacing(2)}px 0`,
  },
}));

export default useStyles;
